module.exports = __webpack_public_path__ + "static/media/042.0cb11ca0.jpg";